import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, brl, maskCPF } from "../../lib/api";
import { toast } from "sonner";
import { ScoreBadge, StatusBadge } from "../../components/Score";
import { ClientTierBadge } from "../../components/TierBadge";
import { Trash, ToggleLeft, ToggleRight } from "@phosphor-icons/react";

export default function AdminClients() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => {
    const { data } = await api.get("/clients", { params: q ? { q } : {} });
    setItems(data);
  };

  useEffect(() => { load(); }, []); // eslint-disable-line

  const toggleActive = async (c) => {
    try {
      const next = c.status === "blocked" ? "active" : "blocked";
      await api.patch(`/clients/${c.id}`, { status: next });
      toast.success(next === "active" ? "Ativada" : "Desativada");
      load();
    } catch { toast.error("Erro"); }
  };

  const remove = async (c) => {
    if (!window.confirm(`Excluir ${c.name}? Todas as vendas, parcelas e dados serao removidos. Esta acao nao pode ser desfeita.`)) return;
    try {
      await api.delete(`/clients/${c.id}`);
      toast.success("Cliente excluida");
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Erro"); }
  };

  return (
    <div data-testid="admin-clients-page">
      <div className="topbar">
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">Carteira global</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mt-1">Clientes</h1>
        </div>
        <div className="flex gap-3 items-center">
          <input
            data-testid="search-clients-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && load()}
            placeholder="Buscar nome, CPF ou telefone"
            className="input-underline" style={{ minWidth: 280 }}
          />
          <button className="brand" onClick={load} data-testid="search-clients-btn">Buscar</button>
        </div>
      </div>

      <div className="table-wrap">
        <table className="crl">
          <thead>
            <tr>
              <th>Cliente</th><th>Tier</th><th>CPF</th><th>Telefone</th><th>Score</th><th>Limite</th><th>Saldo</th><th>Status</th><th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} data-testid={`client-row-${c.id}`}>
                <td className="font-medium"><Link to={`/admin/clientes/${c.id}`} className="hover:underline" data-testid={`client-name-link-${c.id}`}>{c.name}</Link></td>
                <td><ClientTierBadge credit_limit={c.credit_limit} compact /></td>
                <td className="tabular text-[#5C5A57]">{maskCPF(c.cpf)}</td>
                <td className="text-[#5C5A57]">{c.phone}</td>
                <td><ScoreBadge score={c.score} /></td>
                <td className="tabular">{brl(c.credit_limit)}</td>
                <td className="tabular text-[#5C5A57]">{brl(c.open_balance)}</td>
                <td><StatusBadge status={c.status} /></td>
                <td>
                  <div className="flex items-center gap-3">
                    <Link to={`/admin/clientes/${c.id}`} className="text-xs tracking-widest uppercase font-medium hover:underline">Ver</Link>
                    <button onClick={() => toggleActive(c)} className="text-[#5C5A57] hover:text-black" title={c.status === "blocked" ? "Ativar" : "Desativar"} data-testid={`toggle-client-${c.id}`}>
                      {c.status === "blocked" ? <ToggleLeft size={20} /> : <ToggleRight size={20} weight="fill" />}
                    </button>
                    <button onClick={() => remove(c)} className="text-[#8B5E5E] hover:text-[#5C2D2B]" title="Excluir" data-testid={`delete-client-${c.id}`}>
                      <Trash size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan="9" className="text-center text-sm text-[#5C5A57] py-8">Nenhum cliente encontrado.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
